import React from 'react';
import { PremiumButton } from './PremiumButton';
import { ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { AudioPreview } from './AudioPreview';
export function NewHero() {
  return <section className="relative pt-8 pb-12 md:pt-16 md:pb-20 overflow-hidden" data-id="element-363">
      <div className="container mx-auto px-5 max-w-[760px] flex flex-col items-center text-center" data-id="element-364">
        {/* Título */}
        <motion.h1 className="font-serif text-4xl md:text-6xl lg:text-[5.5rem] text-cream leading-[1.1] mb-4 md:mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-365">
          Libre de <span className="italic text-peach" data-id="element-366">Endodolor</span>
        </motion.h1>

        {/* Subtítulo */}
        <motion.p className="text-lg md:text-2xl text-sand mb-6 md:mb-8 max-w-xl leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} data-id="element-367">
          El plan de <strong className="font-bold text-cream" data-id="element-368">21 días</strong>{' '}
          para recuperar tu vientre plano y apagar el dolor de la endometriosis.
        </motion.p>

        {/* Imagen */}
        <motion.div className="w-full mb-8 md:mb-10" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-369">
          <div className="relative aspect-[4/3] md:aspect-[16/11] rounded-3xl overflow-hidden shadow-2xl border border-cream/10" data-id="element-370">
            <img src="https://cdn.magicpatterns.com/uploads/mu1DwDhnB3gRfLKUPhEkF1/Imagen_del_HERO.png" alt="Plan antiinflamatorio Libre de Endodolor" className="w-full h-full object-cover object-center" data-id="element-371" />
          </div>

          {/* Audio preview below the hero image */}
          <div className="mt-6 md:mt-8" data-id="element-372">
            <AudioPreview data-id="element-373" />
          </div>
        </motion.div>

        {/* Botón de CTA */}
        <motion.div className="flex flex-col items-center gap-6 w-full" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-374">
          <PremiumButton className="w-full sm:w-auto text-sm md:text-base px-10 py-4" data-id="element-375">
            ¡QUIERO EMPEZAR POR SOLO $6.36! →
          </PremiumButton>

          <a href="#includes" className="text-sand hover:text-peach transition-colors text-sm border-b border-sand/30 hover:border-peach pb-0.5" data-id="element-376">
            Ver qué incluye →
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-sand/80 mt-2" data-id="element-377">
            <div className="flex items-center gap-2" data-id="element-378">
              <LockIcon className="w-4 h-4 text-peach" data-id="element-379" />
              <span data-id="element-380">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-381">
              <ShieldCheckIcon className="w-4 h-4 text-peach" data-id="element-382" />
              <span data-id="element-383">Garantía 30 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-384">
              <ZapIcon className="w-4 h-4 text-peach" data-id="element-385" />
              <span data-id="element-386">Acceso inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}